module.exports = __webpack_public_path__ + "static/media/reports-02.e123b67c.svg";